// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import MainIndex from '@/views/mainIndex.vue'
import Login from '@/views/login.vue'
import aGroupList from '@/views/aGroup/aGroupList.vue'
import ProductAdd from '@/views/productAdd.vue'
import UserList from '@/views/user/adminUser.vue'
import Message from '@/views/message.vue'

const routes = [
    {
        path: '/',
        name: 'MainIndex',
        component: MainIndex,
        meta: {
            title: '后台首页'
        }
    },
    {
        path: '/a-group/list',
        name: 'aGroupList',
        component: aGroupList,
        meta: {
            title: 'A组'
        }
    },
    {
        path: '/user/list',
        name: 'UserList',
        component: UserList,
        meta: {
            title: '管理员'
        }
    },
    {
        path: '/productAdd',
        name: 'ProductAdd',
        component: ProductAdd,
        meta: {
            title: '产品添加'
        }
    },

    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            title: '后台登录'
        }
    },

    {
        path: '/message',
        name: 'Message',
        component: Message,
        meta: {
            title: '在线留言'
        }
    },

]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
